import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  showRank?: number;
}

export default function MovieCard({ movie, showRank }: MovieCardProps) {
  return (
    <Link
      to={`/category/${movie.categorySlug}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-100">
        <img
          src={movie.image}
          alt={`${movie.title} - ${movie.englishTitle}`}
          title={`${movie.title} ${movie.category} 高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {showRank && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center bg-primary-500 text-background-50 text-xs font-bold rounded-md">
            {showRank}
          </div>
        )}
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-foreground-900/80 text-accent-400 text-xs font-medium px-2 py-1 rounded-md">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating}
        </div>
        {movie.isNew && (
          <div className="absolute bottom-2 left-2 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md">
            新
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="text-background-50 text-sm font-medium flex items-center gap-1">
            <i className="ri-play-circle-fill text-lg"></i>
            立即观看
          </span>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">
          {movie.year} · {movie.category} · {movie.rating}分
        </p>
      </div>
    </Link>
  );
}